/**
 * ARCH §4-7 production-test reading options — the canonical key vocabulary the
 * backend (arch_fill TEST_READING_CELLS) maps into the report's structured grids.
 * Generated from TEST_READINGS_SPEC.md (the contract). Each option's value is the
 * canonical key; the label is what the user sees. Grouped by ARCH section for the
 * picker's <optgroup>s. Unknown/legacy keys still round-trip via the backend fallback.
 */
export interface ArchReadingOption { key: string; label: string; }
export interface ArchReadingGroup { section: string; options: ArchReadingOption[]; }

export const ARCH_TEST_READING_GROUPS: ArchReadingGroup[] = [
  { section: "4. MÉTODO DE BOMBEO HIDRÁULICO (principal)", options: [
    { key: "s4_yacimiento_p1", label: "YACIMIENTO · P1" },
    { key: "s4_fecha_p1", label: "FECHA DEL BOMBEO (año-mes-día) · P1" },
    { key: "s4_pcab_p1", label: "P.Cab (psi) · P1" },
    { key: "s4_pman_p1", label: "P. Man (psi) · P1" },
    { key: "s4_bfpd_p1", label: "BFPD · P1" },
    { key: "s4_bopd_p1", label: "BOPD · P1" },
    { key: "s4_bwpd_p1", label: "BWPD · P1" },
    { key: "s4_salinidad_p1", label: "Salinidad (ppm CI¯) · P1" },
    { key: "s4_bsw_p1", label: "BS&W (%) · P1" },
    { key: "s4_api_p1", label: "° API (60 °F) · P1" },
    { key: "s4_gas_p1", label: "Gas (M scf) · P1" },
    { key: "s4_glr_p1", label: "GLR (scf/stb) · P1" },
    { key: "s4_gor_p1", label: "GOR (scf/stb) · P1" },
    { key: "s4_yacimiento_p2", label: "YACIMIENTO · P2" },
    { key: "s4_fecha_p2", label: "FECHA DEL BOMBEO (año-mes-día) · P2" },
    { key: "s4_pcab_p2", label: "P.Cab (psi) · P2" },
    { key: "s4_pman_p2", label: "P. Man (psi) · P2" },
    { key: "s4_bfpd_p2", label: "BFPD · P2" },
    { key: "s4_bopd_p2", label: "BOPD · P2" },
    { key: "s4_bwpd_p2", label: "BWPD · P2" },
    { key: "s4_salinidad_p2", label: "Salinidad (ppm CI¯) · P2" },
    { key: "s4_bsw_p2", label: "BS&W (%) · P2" },
    { key: "s4_api_p2", label: "° API (60 °F) · P2" },
    { key: "s4_gas_p2", label: "Gas (M scf) · P2" },
    { key: "s4_glr_p2", label: "GLR (scf/stb) · P2" },
    { key: "s4_gor_p2", label: "GOR (scf/stb) · P2" },
    { key: "s4_yacimiento_p3", label: "YACIMIENTO · P3" },
    { key: "s4_fecha_p3", label: "FECHA DEL BOMBEO (año-mes-día) · P3" },
    { key: "s4_pcab_p3", label: "P.Cab (psi) · P3" },
    { key: "s4_pman_p3", label: "P. Man (psi) · P3" },
    { key: "s4_bfpd_p3", label: "BFPD · P3" },
    { key: "s4_bopd_p3", label: "BOPD · P3" },
    { key: "s4_bwpd_p3", label: "BWPD · P3" },
    { key: "s4_salinidad_p3", label: "Salinidad (ppm CI¯) · P3" },
    { key: "s4_bsw_p3", label: "BS&W (%) · P3" },
    { key: "s4_api_p3", label: "° API (60 °F) · P3" },
    { key: "s4_gas_p3", label: "Gas (M scf) · P3" },
    { key: "s4_glr_p3", label: "GLR (scf/stb) · P3" },
    { key: "s4_gor_p3", label: "GOR (scf/stb) · P3" },
  ] },
  { section: "4.1. INYECCIÓN", options: [
    { key: "s41_presion_p1", label: "Presión (psi) · P1" },
    { key: "s41_bpd_p1", label: "BPD · P1" },
    { key: "s41_bsw_p1", label: "BS&W % · P1" },
    { key: "s41_api_p1", label: "°API · P1" },
    { key: "s41_presion_p2", label: "Presión (psi) · P2" },
    { key: "s41_bpd_p2", label: "BPD · P2" },
    { key: "s41_bsw_p2", label: "BS&W % · P2" },
    { key: "s41_api_p2", label: "°API · P2" },
    { key: "s41_presion_p3", label: "Presión (psi) · P3" },
    { key: "s41_bpd_p3", label: "BPD · P3" },
    { key: "s41_bsw_p3", label: "BS&W % · P3" },
    { key: "s41_api_p3", label: "°API · P3" },
    { key: "s41_presion_p4", label: "Presión (psi) · P4" },
    { key: "s41_bpd_p4", label: "BPD · P4" },
    { key: "s41_bsw_p4", label: "BS&W % · P4" },
    { key: "s41_api_p4", label: "°API · P4" },
    { key: "s41_presion_p5", label: "Presión (psi) · P5" },
    { key: "s41_bpd_p5", label: "BPD · P5" },
    { key: "s41_bsw_p5", label: "BS&W % · P5" },
    { key: "s41_api_p5", label: "°API · P5" },
    { key: "s41_presion_p6", label: "Presión (psi) · P6" },
    { key: "s41_bpd_p6", label: "BPD · P6" },
    { key: "s41_bsw_p6", label: "BS&W % · P6" },
    { key: "s41_api_p6", label: "°API · P6" },
  ] },
  { section: "4.2. RETORNO", options: [
    { key: "s42_bpd_p1", label: "BPD · P1" },
    { key: "s42_bsw_p1", label: "BS&W % · P1" },
    { key: "s42_api_p1", label: "°API · P1" },
    { key: "s42_bpd_p2", label: "BPD · P2" },
    { key: "s42_bsw_p2", label: "BS&W % · P2" },
    { key: "s42_api_p2", label: "°API · P2" },
    { key: "s42_bpd_p3", label: "BPD · P3" },
    { key: "s42_bsw_p3", label: "BS&W % · P3" },
    { key: "s42_api_p3", label: "°API · P3" },
    { key: "s42_bpd_p4", label: "BPD · P4" },
    { key: "s42_bsw_p4", label: "BS&W % · P4" },
    { key: "s42_api_p4", label: "°API · P4" },
    { key: "s42_bpd_p5", label: "BPD · P5" },
    { key: "s42_bsw_p5", label: "BS&W % · P5" },
    { key: "s42_api_p5", label: "°API · P5" },
    { key: "s42_bpd_p6", label: "BPD · P6" },
    { key: "s42_bsw_p6", label: "BS&W % · P6" },
    { key: "s42_api_p6", label: "°API · P6" },
  ] },
  { section: "4.3. BOMBA", options: [
    { key: "s43_tipo_p1", label: "TIPO · P1" },
    { key: "s43_modelo_p1", label: "MODELO · P1" },
    { key: "s43_etapas_p1", label: "ETAPAS · P1" },
    { key: "s43_potencia_p1", label: "POTENCIA · P1" },
    { key: "s43_horas_p1", label: "HORAS DE EVALUACIÓN · P1" },
    { key: "s43_tipo_p2", label: "TIPO · P2" },
    { key: "s43_modelo_p2", label: "MODELO · P2" },
    { key: "s43_etapas_p2", label: "ETAPAS · P2" },
    { key: "s43_potencia_p2", label: "POTENCIA · P2" },
    { key: "s43_horas_p2", label: "HORAS DE EVALUACIÓN · P2" },
    { key: "s43_tipo_p3", label: "TIPO · P3" },
    { key: "s43_modelo_p3", label: "MODELO · P3" },
    { key: "s43_etapas_p3", label: "ETAPAS · P3" },
    { key: "s43_potencia_p3", label: "POTENCIA · P3" },
    { key: "s43_horas_p3", label: "HORAS DE EVALUACIÓN · P3" },
  ] },
  { section: "5.1. MÉTODO BOMBEO ELÉCTRICO / FLUJO NATURAL", options: [
    { key: "s51_yacimiento_p1", label: "YACIMIENTO · P1" },
    { key: "s51_fecha_p1", label: "FECHA (año-mes-día) · P1" },
    { key: "s51_pcab_p1", label: "P.Cab (psi) · P1" },
    { key: "s51_pman_p1", label: "P. Man (psi) · P1" },
    { key: "s51_psep_p1", label: "P. Sep (psi) · P1" },
    { key: "s51_tempsep_p1", label: "Temp Sep (F) · P1" },
    { key: "s51_bfpd_p1", label: "BFPD · P1" },
    { key: "s51_bopd_p1", label: "BOPD · P1" },
    { key: "s51_salinidad_p1", label: "Salinidad (ppm CI¯) · P1" },
    { key: "s51_bsw_p1", label: "BS&W (%) · P1" },
    { key: "s51_api_p1", label: "°API · P1" },
    { key: "s51_glr_p1", label: "GLR (scf/stb) · P1" },
    { key: "s51_gor_p1", label: "GOR (scf/stb) · P1" },
    { key: "s51_gas_p1", label: "Gas (M scf) · P1" },
    { key: "s51_tipobomba_p1", label: "Tipo Bomba · P1" },
    { key: "s51_yacimiento_p2", label: "YACIMIENTO · P2" },
    { key: "s51_fecha_p2", label: "FECHA (año-mes-día) · P2" },
    { key: "s51_pcab_p2", label: "P.Cab (psi) · P2" },
    { key: "s51_pman_p2", label: "P. Man (psi) · P2" },
    { key: "s51_psep_p2", label: "P. Sep (psi) · P2" },
    { key: "s51_tempsep_p2", label: "Temp Sep (F) · P2" },
    { key: "s51_bfpd_p2", label: "BFPD · P2" },
    { key: "s51_bopd_p2", label: "BOPD · P2" },
    { key: "s51_salinidad_p2", label: "Salinidad (ppm CI¯) · P2" },
    { key: "s51_bsw_p2", label: "BS&W (%) · P2" },
    { key: "s51_api_p2", label: "°API · P2" },
    { key: "s51_glr_p2", label: "GLR (scf/stb) · P2" },
    { key: "s51_gor_p2", label: "GOR (scf/stb) · P2" },
    { key: "s51_gas_p2", label: "Gas (M scf) · P2" },
    { key: "s51_tipobomba_p2", label: "Tipo Bomba · P2" },
    { key: "s51_yacimiento_p3", label: "YACIMIENTO · P3" },
    { key: "s51_fecha_p3", label: "FECHA (año-mes-día) · P3" },
    { key: "s51_pcab_p3", label: "P.Cab (psi) · P3" },
    { key: "s51_pman_p3", label: "P. Man (psi) · P3" },
    { key: "s51_psep_p3", label: "P. Sep (psi) · P3" },
    { key: "s51_tempsep_p3", label: "Temp Sep (F) · P3" },
    { key: "s51_bfpd_p3", label: "BFPD · P3" },
    { key: "s51_bopd_p3", label: "BOPD · P3" },
    { key: "s51_salinidad_p3", label: "Salinidad (ppm CI¯) · P3" },
    { key: "s51_bsw_p3", label: "BS&W (%) · P3" },
    { key: "s51_api_p3", label: "°API · P3" },
    { key: "s51_glr_p3", label: "GLR (scf/stb) · P3" },
    { key: "s51_gor_p3", label: "GOR (scf/stb) · P3" },
    { key: "s51_gas_p3", label: "Gas (M scf) · P3" },
    { key: "s51_tipobomba_p3", label: "Tipo Bomba · P3" },
  ] },
  { section: "5.2. PARÁMETROS", options: [
    { key: "s52_fecha_p1", label: "FECHA (año-mes-día) · P1" },
    { key: "s52_pintake_p1", label: "P Intake (psi) · P1" },
    { key: "s52_pdescarga_p1", label: "P Descarga (psi) · P1" },
    { key: "s52_tintake_p1", label: "T Intake (°F) · P1" },
    { key: "s52_tmotor_p1", label: "T Motor (°F) · P1" },
    { key: "s52_frecuencia_p1", label: "Frecuencia (Hz) · P1" },
    { key: "s52_amperaje_p1", label: "Amperaje (A) · P1" },
    { key: "s52_voltaje_p1", label: "Voltaje (V) · P1" },
    { key: "s52_fecha_p2", label: "FECHA (año-mes-día) · P2" },
    { key: "s52_pintake_p2", label: "P Intake (psi) · P2" },
    { key: "s52_pdescarga_p2", label: "P Descarga (psi) · P2" },
    { key: "s52_tintake_p2", label: "T Intake (°F) · P2" },
    { key: "s52_tmotor_p2", label: "T Motor (°F) · P2" },
    { key: "s52_frecuencia_p2", label: "Frecuencia (Hz) · P2" },
    { key: "s52_amperaje_p2", label: "Amperaje (A) · P2" },
    { key: "s52_voltaje_p2", label: "Voltaje (V) · P2" },
    { key: "s52_fecha_p3", label: "FECHA (año-mes-día) · P3" },
    { key: "s52_pintake_p3", label: "P Intake (psi) · P3" },
    { key: "s52_pdescarga_p3", label: "P Descarga (psi) · P3" },
    { key: "s52_tintake_p3", label: "T Intake (°F) · P3" },
    { key: "s52_tmotor_p3", label: "T Motor (°F) · P3" },
    { key: "s52_frecuencia_p3", label: "Frecuencia (Hz) · P3" },
    { key: "s52_amperaje_p3", label: "Amperaje (A) · P3" },
    { key: "s52_voltaje_p3", label: "Voltaje (V) · P3" },
  ] },
  { section: "5.3. TIEMPO DE EVALUACIÓN", options: [
    { key: "s53_horas_p1", label: "HORAS · P1" },
    { key: "s53_horas_p2", label: "HORAS · P2" },
    { key: "s53_horas_p3", label: "HORAS · P3" },
  ] },
  { section: "6.1. POZO GAS", options: [
    { key: "s61_yacimiento_p1", label: "YACIMIENTO · P1" },
    { key: "s61_fecha_p1", label: "FECHA (año-mes-día) · P1" },
    { key: "s61_choque_p1", label: "Choque (in) · P1" },
    { key: "s61_pcab_p1", label: "P.Cab (psi) · P1" },
    { key: "s61_psep_p1", label: "P. Sep (psi) · P1" },
    { key: "s61_pman_p1", label: "P. Man (psi) · P1" },
    { key: "s61_gpd_p1", label: "GPD (MM scf) · P1" },
    { key: "s61_bwpd_p1", label: "BWPD · P1" },
    { key: "s61_gravedad_p1", label: "Gravedad Especifica · P1" },
    { key: "s61_apicondensado_p1", label: "°API Condensado · P1" },
    { key: "s61_condensadobopd_p1", label: "Condensado BOPD · P1" },
    { key: "s61_tc_p1", label: "Tc (°F) · P1" },
    { key: "s61_horas_p1", label: "Horas Evaluadas · P1" },
    { key: "s61_yacimiento_p2", label: "YACIMIENTO · P2" },
    { key: "s61_fecha_p2", label: "FECHA (año-mes-día) · P2" },
    { key: "s61_choque_p2", label: "Choque (in) · P2" },
    { key: "s61_pcab_p2", label: "P.Cab (psi) · P2" },
    { key: "s61_psep_p2", label: "P. Sep (psi) · P2" },
    { key: "s61_pman_p2", label: "P. Man (psi) · P2" },
    { key: "s61_gpd_p2", label: "GPD (MM scf) · P2" },
    { key: "s61_bwpd_p2", label: "BWPD · P2" },
    { key: "s61_gravedad_p2", label: "Gravedad Especifica · P2" },
    { key: "s61_apicondensado_p2", label: "°API Condensado · P2" },
    { key: "s61_condensadobopd_p2", label: "Condensado BOPD · P2" },
    { key: "s61_tc_p2", label: "Tc (°F) · P2" },
    { key: "s61_horas_p2", label: "Horas Evaluadas · P2" },
    { key: "s61_yacimiento_p3", label: "YACIMIENTO · P3" },
    { key: "s61_fecha_p3", label: "FECHA (año-mes-día) · P3" },
    { key: "s61_choque_p3", label: "Choque (in) · P3" },
    { key: "s61_pcab_p3", label: "P.Cab (psi) · P3" },
    { key: "s61_psep_p3", label: "P. Sep (psi) · P3" },
    { key: "s61_pman_p3", label: "P. Man (psi) · P3" },
    { key: "s61_gpd_p3", label: "GPD (MM scf) · P3" },
    { key: "s61_bwpd_p3", label: "BWPD · P3" },
    { key: "s61_gravedad_p3", label: "Gravedad Especifica · P3" },
    { key: "s61_apicondensado_p3", label: "°API Condensado · P3" },
    { key: "s61_condensadobopd_p3", label: "Condensado BOPD · P3" },
    { key: "s61_tc_p3", label: "Tc (°F) · P3" },
    { key: "s61_horas_p3", label: "Horas Evaluadas · P3" },
  ] },
  { section: "6.2. TIEMPO DE EVALUACIÓN", options: [
    { key: "s62_horas_p1", label: "HORAS · P1" },
    { key: "s62_horas_p2", label: "HORAS · P2" },
    { key: "s62_horas_p3", label: "HORAS · P3" },
  ] },
  { section: "7. PRUEBAS DE INYECTIVIDAD", options: [
    { key: "s7_tiempo_p1", label: "Tiempo (min) · P1" },
    { key: "s7_rata_p1", label: "Rata de Inyección (bbl/min) · P1" },
    { key: "s7_piny_p1", label: "P. Iny (psi) · P1" },
    { key: "s7_tiempo_p2", label: "Tiempo (min) · P2" },
    { key: "s7_rata_p2", label: "Rata de Inyección (bbl/min) · P2" },
    { key: "s7_piny_p2", label: "P. Iny (psi) · P2" },
    { key: "s7_tiempo_p3", label: "Tiempo (min) · P3" },
    { key: "s7_rata_p3", label: "Rata de Inyección (bbl/min) · P3" },
    { key: "s7_piny_p3", label: "P. Iny (psi) · P3" },
  ] },
];

/** Flat key→label lookup for showing a saved reading's friendly name. */
export const ARCH_TEST_READING_LABEL: Record<string, string> = Object.fromEntries(
  ARCH_TEST_READING_GROUPS.flatMap((g) => g.options.map((o) => [o.key, o.label])),
);
